module.exports = __webpack_public_path__ + "static/media/IMG-5209.55a87147.JPG";